module.exports = __webpack_public_path__ + "img/logo-flat-light.f230ea31.svg";